var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "order-refund-summary flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Refund has been created.\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v("\n    The refund has been processed successfully.\n  "),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "refund-details" },
        [
          _c("el-card", { attrs: { shadow: "never" } }, [
            _c(
              "div",
              { staticClass: "flex flex-col" },
              [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Items\n        "),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ItemRefundSummaryList", {
                  attrs: {
                    "items-to-refund": _vm.itemsToRefund,
                    "refund-shipping": _vm.refundShipping,
                    "shipping-total": _vm.shippingTotal,
                  },
                }),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "summary-header" }, [
                    _vm._v("\n            Customer info\n          "),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Name\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Phone Number\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_phone))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Email\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_email))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "summary-header" }, [
                    _vm._v("\n            Payments\n          "),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v(
                        "\n              Total Refunded Amount\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.formattedAmount(
                              _vm.totalRefundAmount,
                              _vm.refundCurrency
                            )
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Currency\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.refundCurrency))]),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "flex-1" }, [
          _vm._v("\n        Refund Summary\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }